import { Injectable, Renderer2, RendererFactory2, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BehaviorSubject, Observable, Subject, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { AnalyticsService } from "mis-crystal-design-system/analytics";
import { map } from 'rxjs';
import { DataService } from 'src/app/data.service';
import { DateUtils } from 'src/app/utils/days-utils';

export interface ITicketDetails {
   ticketType : string;
   ticketId:number;
   ticketUrl ?:string;
}
declare let gtag: Function;
@Injectable({
   providedIn: 'root'
})
export class CommonCabService {
   private renderer: Renderer2;

   constructor(private http:HttpClient,private router: Router,rendererFactory: RendererFactory2,
      private analyticsService: AnalyticsService) { 
        if(environment?.ANALYTICS_KEY){
          this.renderer = rendererFactory.createRenderer(null, null);
          this.analyticsService.insertScript(environment.ANALYTICS_KEY, this.renderer); 
        }
      }
   response: any;
   // allEmployeesDetails$ = new BehaviorSubject<any>([]);
   employeeStatusCount$ = new BehaviorSubject<any>({});

   employeeDetails$ = new BehaviorSubject<any>([]);
   //busStopsDetails$ = new BehaviorSubject<any>([]);
   driverActions$ = new BehaviorSubject<any>([]);
   loginLogoutStops$ = new BehaviorSubject<any>([]);
   buid: any;
   source:any='';
   NONCE_TOKEN: any;
   tripId: any;
   dutyId: any;
   dutyUuid: any;
   cabId: any;
   routeSource: any;
   private safetyAlertSubject = new BehaviorSubject<[]>([]);;
   safetyAlert$ = this.safetyAlertSubject.asObservable();
   date: any;
   geofenceRadius:any;
   attendance$ = new BehaviorSubject<any>(
   {
      adhocCount: 0,
      noShowCount: 0,
      totalPlannedEmployeesToBoard: 0,
      plannedemployeesBoarded: 0,
      totalCapacity: 0
   }
   );
   womenTravellingAlone$ = new BehaviorSubject<boolean>(false);
   timeZone = 'Asia/Kolkata';
   ticketDetails:ITicketDetails[] = []
   tripDetails:any;
   dataService = inject(DataService)
   getTimeZone() {
      return this.http.get(`${environment.API_URL}/ets/${this.buid}/timeZone`);
   }

   getGeofence() {
      return this.http.get(`${environment.CONFIGURATION_SERVICE_API}/DRIVER_APP/properties/buid/${this.buid}/property/LOGIN_TRIP_OVER_DISTANCE`);
  //    return of({
  //     "LOGIN_TRIP_OVER_DISTANCE": "75"
  // })
    }

   goToTripReplay() {
      this.router.navigate(['trip-view/trip-replay-cab'], { queryParams: { buid: this.buid, tripId: this.tripId, ...(this.source ? {source:this.source } : {})}});
   }

   getTripDetails(tripId: any) {
      const apiUrl = `${environment.API_URL}/tracking/buid/${this.buid}/trip/${tripId}`;

      return this.http.get(apiUrl).pipe(
         tap((response) => {
            this.dutyId = response?.['dutyId'];
            this.tripDetails = response?.['tripDetails'];
            this.tripId = response?.['tripDetails']?.['tripId'];
            this.dutyUuid = response?.['dutyUuid'];
            this.cabId = response?.['tripDetails']?.['vehicle']?.['cabId'];
            this.routeSource = response?.['tripDetails']?.['routeSource'];
            this.date = DateUtils.formatDate(response['tripDetails']['shift']['date'], 'DD/MM/YYYY');
            this.safetyAlertSubject.next(response?.['tripDetails']?.['safetyAlert']);
         })
      );

   }

   getDriverActions(tripUUID?: any, tripId?: any) {
      return this.http.get(`${environment.API_URL}/tracking/buid/${this.buid}/get-driver-action?tripUUID=${tripUUID}&tripId=${tripId}`)
   }


   getTrackingSession(legUUID: any, sequenceId: any, imei: any, dataSource: any, isCompletedTrip: boolean, isFixedDevice: boolean) {
      const IMEI = this.getDeviceIMEI(isFixedDevice)
      return this.http.get(`${environment.API_URL}/tracking/buid/${this.buid}/get-tracking-data?legUUID=${legUUID}&suquenceId=${sequenceId}&imei=${IMEI}&isCompletedTrip=${isCompletedTrip}&isFixedDevice=${isFixedDevice}&tripId=${this.tripId}` )
   }

   getDeviceIMEI(isFixedDevice:boolean){
      const vehicle = this.tripDetails?.vehicle;
      if (!vehicle) {
         return null;
      }
      return isFixedDevice ? 
       vehicle?.externalDeviceImei :
       vehicle?.deviceDTO?.imei
   }

   getDeviceHealth(date: any, deviceId: any, deviceImei: any) {
      const formattedDate = DateUtils.customFormatDate(date, 'MMM DD, YYYY', 'DD-MM-YYYY');

      return this.http.get(`${environment.API_URL}/healthlogs?buid=${this.buid}&date=${formattedDate}&deviceId=${deviceId}&deviceImei=${deviceImei}`)
   }

   createOldRoute() {
      const buid = this.dataService.ETS_BUID;
      if (window.parent.location.href.includes('.moveinsync.in')) {
         if(this.NONCE_TOKEN) {
            return `https://${buid.split('-')[0]}.moveinsync.in/${buid.split('-')[1]}/trackVehicle.jsp?type=duty&dutyId=${this.dutyId}&tripId=${this.tripId}&cabId=${this.cabId}&routeSource=${this.routeSource}&date=${this.date}&CSRF_NONCE=${this.NONCE_TOKEN}`;
         }
         return `https://${buid.split('-')[0]}.moveinsync.in/${buid.split('-')[1]}/trackVehicle.jsp?type=duty&dutyId=${this.dutyId}&tripId=${this.tripId}&cabId=${this.cabId}&routeSource=${this.routeSource}&date=${this.date}`;
      }
      if(this.NONCE_TOKEN) {
         return `https://${buid.split('-')[0]}.moveinsync.com/${buid.split('-')[1]}/trackVehicle.jsp?type=duty&dutyId=${this.dutyId}&tripId=${this.tripId}&cabId=${this.cabId}&routeSource=${this.routeSource}&date=${this.date}&CSRF_NONCE=${this.NONCE_TOKEN}`;
      }
      return `https://${buid.split('-')[0]}.moveinsync.com/${buid.split('-')[1]}/trackVehicle.jsp?type=duty&dutyId=${this.dutyId}&tripId=${this.tripId}&cabId=${this.cabId}&routeSource=${this.routeSource}&date=${this.date}`;
   }

   getEtsUrl()
   {
      return this.http.get(environment.API_URL+"/dashboard/"+this.buid+"/url",{ responseType: 'text' })
   }

   sendEvent(action: string, category: string, label: string, value: string, buid: string,eventTime: string) {
      const eventData = {
        event_category: category,
        event_label: label,
        value: value,
        buid: buid,
        event_time: eventTime
      };
      gtag('event', action, eventData);
    }
    
   getTicketDetails(){
      return this.http.get(`${environment.API_URL}/ticketing/ticket/trip-view/${this.buid}/${this.tripId}`)
   }

   getDeviceInfo(){
      const headers = new HttpHeaders({
         
         'X-tenantID' : this.buid
      })
      return this.http.get(`${environment.API_URL}/tripdeviceinfo?dutyId=${this.dutyId}&buid=${this.buid}&dutyUuid=${this.dutyUuid}&tripId=${this.tripId}`, {headers: headers})

   }
   getReleaseNotesData() {
      const name = 'Driver Device Versions';
      return this.http.get(`${environment.API_URL}/releaseNotes`).pipe(
         map((notes: any[]) => notes.find((note: any) => note.name.includes(name)))
      );
    }
    
}
